const LOYALTY_BONUS_RULE_APPLICABLE_PRODUCT_TYPES: Array<App.LoyaltyBonusRuleApplicableProductType> = [
  'rental',
  'lux_plus',
  'cruise_group_1',
  'cruise_group_2',
  'cruise_group_3',
  'hotel_flash',
  'hotel_lpc',
  'tour_bank',
  'trusted_partner_tour',
  'le_tour',
]

const LOYALTY_BONUS_RULE_APPLICABLE_PRODUCT_TYPES_SET = new Set<string>(LOYALTY_BONUS_RULE_APPLICABLE_PRODUCT_TYPES)

function isLoyaltyProductTypeBonusApplicable(productType: App.LoyaltyProductType): productType is App.LoyaltyBonusRuleApplicableProductType {
  return LOYALTY_BONUS_RULE_APPLICABLE_PRODUCT_TYPES_SET.has(productType)
}

export default isLoyaltyProductTypeBonusApplicable
